"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsManager = void 0;
class SubscriptionsManager {
    constructor() {
        this._subscriptions = [];
    }
    add(subscription) {
        this._subscriptions.push(subscription);
    }
    addSubscription(subscription) {
        this._subscriptions.push(subscription);
    }
    dispose() {
        if (this._subscriptions) {
            for (const subscription of this._subscriptions) {
                if (subscription.unsubscribe) {
                    subscription.unsubscribe();
                }
                if (subscription.remove) {
                    subscription.remove();
                }
            }
        }
    }
}
exports.SubscriptionsManager = SubscriptionsManager;
//# sourceMappingURL=subscriptions-manager.js.map